import $ from '../$';
import each from '../functions/each';
$.each = each;
